import type { MasternodeWithStats } from '../../hooks/useMasternodes';

export function calculateROI(nodes: MasternodeWithStats[]): {
  daily: number;
  monthly: number;
  yearly: number;
} {
  const totalDailyRewards = nodes.reduce((sum, n) => sum + (n.rewardStats?.rewardsPerDay ?? 0), 0);
  const totalCollateral = nodes.reduce((sum, n) => sum + (n.tier ?? 0), 0);

  if (!totalCollateral) return { daily: 0, monthly: 0, yearly: 0 };

  const daily = (totalDailyRewards / totalCollateral) * 100;
  const monthly = daily * 30.44;
  const yearly = daily * 365.25;

  return { daily, monthly, yearly };
}

export function formatROI(value: number): string {
  return `${value.toFixed(3)}%`;
}